import type { paths } from "../types/address-book-api.generated";
import * as api from "./client";

// ============================================================================
// Type Definitions from Address Book API
// ============================================================================

type APIOffice =
  paths["/api/v1/offices"]["get"]["responses"]["200"]["content"]["application/json"]["offices"][number];

export type Office = APIOffice;

export type OfficesListResponse =
  paths["/api/v1/offices"]["get"]["responses"]["200"]["content"]["application/json"];

export type OfficeDetailResponse =
  paths["/api/v1/offices/{id}"]["get"]["responses"]["200"]["content"]["application/json"];

// ============================================================================
// Countries (not in generated types yet)
// ============================================================================

export type OfficeCountry = {
  id: number;
  name: string;
};

type CountriesResponse = {
  countries: OfficeCountry[];
  pagination: { total: number; limit: number; offset: number; hasMore: boolean };
};

// ============================================================================
// Filter Types
// ============================================================================

type OfficeListFilters = {
  companyWpId?: number;
  countryId?: number;
  name?: string;
  city?: string;
  limit?: number;
  offset?: number;
};

export const offices = {
  getAll: async (filters?: OfficeListFilters): Promise<OfficesListResponse> => {
    const params = new URLSearchParams();
    if (filters?.companyWpId) params.append("companyWpId", filters.companyWpId.toString());
    if (filters?.countryId) params.append("countryId", filters.countryId.toString());
    if (filters?.name) params.append("name", filters.name);
    if (filters?.city) params.append("city", filters.city);
    if (filters?.limit !== undefined) params.append("limit", filters.limit.toString());
    if (filters?.offset !== undefined) params.append("offset", filters.offset.toString());

    const query = params.toString() ? `?${params.toString()}` : "";
    return api.get<OfficesListResponse>(`/v1/address-book/offices${query}`);
  },

  getById: async (id: number): Promise<Office> => {
    const response = await api.get<OfficeDetailResponse>(
      `/v1/address-book/offices/by-office-id/${id}`,
    );
    return response.office;
  },

  getCountries: async (): Promise<OfficeCountry[]> => {
    const response = await api.get<CountriesResponse>("/v1/address-book/offices/countries");
    return response.countries;
  },
};
